import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import Header from '../components/Secciones/Header';
import Footer from '../components/Secciones/Footer';
import './ThankYou.css';

const contentByType = {
  order: {
    eyebrow: 'Payment confirmed',
    title: 'Thank you for your order.',
    description: 'Your payment was received and the order is moving into processing. You can follow its status from your account.',
    primaryLabel: 'View my orders',
    primaryHref: '/orders'
  },
  contact: {
    eyebrow: 'Message received',
    title: 'Thank you for reaching out.',
    description: 'A member of our industrial support team will review your requirement and contact you with a clear next step.',
    primaryLabel: 'Explore our brands',
    primaryHref: '/brands'
  },
  quote: {
    eyebrow: 'Quote request received',
    title: 'Thank you for the opportunity.',
    description: 'Our team will review the product, quantity and delivery details you submitted and follow up with pricing or any questions.',
    primaryLabel: 'Browse in-stock products',
    primaryHref: '/search?q=*&inStock=true&page=1'
  }
};

export default function ThankYou() {
  const [searchParams] = useSearchParams();
  const type = searchParams.get('type');
  const orderNumber = searchParams.get('order');
  const content = contentByType[type] || contentByType.contact;

  return (
    <div className="ty-page">
      <Header />
      <main className="ty-main">
        <section className="ty-card" aria-labelledby="thank-you-title">
          <span className="ty-check" aria-hidden="true"><i className="fas fa-check" /></span>
          <span className="ty-eyebrow">{content.eyebrow}</span>
          <h1 id="thank-you-title">{content.title}</h1>
          {type === 'order' && orderNumber && <p className="ty-reference">Order #{orderNumber}</p>}
          <p className="ty-description">{content.description}</p>
          <div className="ty-actions">
            <Link className="ty-primary" to={content.primaryHref}>{content.primaryLabel} <span>→</span></Link>
            <Link className="ty-secondary" to="/">Return home</Link>
          </div>
          <div className="ty-help">
            <strong>Need immediate assistance?</strong>
            <a href="tel:+19563380631">+1 956-338-0631</a>
            <a href="mailto:inquiry@valleyintlsupply.com">inquiry@valleyintlsupply.com</a>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}

